<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" sm="1">
        <router-link
          :to="{ name: 'EstimatedInsuranceRequiredOutput' }"
          class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="3" offset-sm="1" class="mt-6">
        <v-img
          :src="
            require(`@/assets/${whitelabel.images.insuranceAgeRestrictedPage}`)
          "
          aspect-ratio="1"
          alt="insurance age restricted"
        />
      </v-col>
      <v-col cols="12" sm="6" offset-sm="1">
        <h2>Sorry, we can't help right now</h2>
        <p>
          We are sorry but we can only offer estate policies for persons between
          the age of 17 and 59 years old. We continue to work with our insurer
          to look to increase this age limit and keep you informed of any
          changes.
        </p>
        <v-btn
          rounded
          depressed
          large
          color="primary"
          @click="$router.push({ name: 'OverviewPage' })"
        >
          <span>Next</span><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'AgeRestricted',
  };
</script>
